import { Fonts } from '../../config/theme';
import styled from 'styled-components';

type WrapperProps = {
  primary?: boolean;
  width?: string;
  bg?: string;
  textcolor?: boolean;
};

const Wrapper = styled.button<WrapperProps>`
  padding: 11px 15px;
  color: ${(props: WrapperProps) =>
    props.textcolor ? 'var(--color-light)' : '#4C6870'};
  background: ${(props: WrapperProps) =>
    props.primary ? 'var(--app-color-dark)' : 'transparent'};
  background-color: ${(props: WrapperProps) => props.bg};
  width: ${(props: WrapperProps) => props.width};
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  font-family: ${Fonts.secondary}, sans-serif;
  border: none;
  outline: none;
  border-radius: 4px;
  letter-spacing: 1px;
  cursor: pointer;
`;

export default Wrapper;
